import WidgetView from '../widget-view'
import PerspectiveConfig from './perspective-config'
import template from './perspective-view.hbs'
import togglePrefixedClass from 'scoreboard/components/toggle-prefixed-class'

var LinearGaugeView = WidgetView.extend({
	className: 'widget perspective has-drilldown',
	resizable: true,
	configClass: PerspectiveConfig,

	nonFetchProperties: WidgetView.prototype.nonFetchProperties.concat('labelDirection'),

	render: function () {
		WidgetView.prototype.render.apply(this, arguments)

		if (this.$('.content').length === 0) {
			var sn = this.model.data.scorecards(this.model.properties.get('scorecardItemId'))
			this.$el.append(template({
				label: sn ? sn.label : ''
			}))
		}

		togglePrefixedClass(this.el, 'font-size', this.model.properties.get('fontSize'))

		var direction = this.model.properties.get('labelDirection')
		this.$el
			.toggleClass('label-direction-horizontal', direction === 'horizontal')
			.toggleClass('label-direction-vertical', direction === 'vertical')

		this._positionLabel()
		this.container.on('resized', this._positionLabel.bind(this))

		this.readyForDisplayAndExport()

		return this
	},

	_positionLabel: function () {
		var width = this.model.wob.get('width')
		var height = this.model.wob.get('height')
		var label = this.$('.label')

		if (this.model.properties.get('labelDirection') === 'vertical') {
			// To have the label text vertically oriented on the left side, reverse the width and height,
			// rotate it around the top left (see perspective.scss), and shift it down
			label.css({
				width: height + 'px',
				height: width + 'px',
				top: height + 'px'
			})
		} else {
			label.css({
				width: '100%',
				height: '100%',
				top: ''
			})
		}
	}
})

export default LinearGaugeView

LinearGaugeView.__filename__ = 'dashboards/widgets/perspective/perspective-view.js'
